// extracted by mini-css-extract-plugin
export default {"positiveCostSaving":"Detail_positiveCostSaving__zWcMK","negativeCostSaving":"Detail_negativeCostSaving__zZjSv","subHeading":"Detail_subHeading__HjBgG"};